import Icon from '@ant-design/icons';
import { Popover } from 'antd';

import TipsSvg from '@/components/Icon/svgs/guide.svg';
import { useTranslation } from '@/i18n/client';

import { PricingCards } from './PricingCards';

export default function Pricing(props: { className?: string }): JSX.Element {
  const { className } = props;

  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className="font-medium text-sm leading-6 text-primary-black flex items-center mb-3">
        {t('menu.subscriptionModal.pricingPlan')}
        <Popover
          content="Please be aware that this is a limited-time offer. After this period, we may adjust the usage limitations and pricing in response product evolution and market feedback."
          overlayStyle={{ maxWidth: 400 }}
          placement="right"
        >
          <Icon className="ml-1 text-sm text-primary-black" component={TipsSvg} />
        </Popover>
      </div>
      <PricingCards />
    </div>
  );
}
